import React, { useState } from "react";
import InvoiceAmount from "./Main";

const DEFAULT_VALUE = {
  value: "",
  warning: null,
  message: 'Testing'
}

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})

  return (
    <>
      <InvoiceAmount
        // default_value={"20.01"}
        value={value}
        // show_message={true}
        onChange={(val) => setValue(val)}
      />
      <br/>
      <br/>
      {value && <ul>
        <li>Value: {value.value}</li>
      </ul>}
    </>
  )
}

export default Demo;
